module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ts-filter"
  }, [(_vm.title) ? _c('div', {
    staticClass: "ts-filter-title"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ts-filter-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-39dd8578"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/common/tsFilter.vue
// module id = 823
// module chunks = 39